import React, {useContext} from 'react';
import moment from 'moment';

import {AppContext} from '../../../../AppModule/Context';
import {withWidgetContext} from '../../../widgetComponent/widgetContextProvider';

import ButtonComponent from '../../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import Calendar from '../../../../assets/svgComponents/Calendar';
import Caret from '../../../../assets/svgComponents/Caret';
import Check from '../../../../assets/svgComponents/Check';
import Clock from '../../../../assets/svgComponents/Clock';
import Spinner from '../../../common/genericComponents/spinner';

import scheduleUtils from '../../scheduleUtils';
import utilsService from '../../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../../config/consts';

import './clientBookingOptionRow.css';

const ClientBookingOptionRow = (props) => {
  const context = useContext(AppContext);
  const rangeStartTimeSender = moment.utc(
    props.bookingOption?.rangeStartTimeSender,
  );
  const rangeStartTimeSenderDate = new Date(rangeStartTimeSender);
  const isOverdue =
    props.bookingOption?.rangeEndTimeSender < new Date().getTime();

  const getDayStr = scheduleUtils
    .getLocaleSpecificMomentObj(
      rangeStartTimeSenderDate,
      props.widgetLanguageLocaleKey,
    )
    .tz(props.selectedTimezone)
    .format('ddd, MMM D,');
  const getYearStr = moment(rangeStartTimeSenderDate)
    .tz(props.selectedTimezone)
    .format('YYYY');
  let getStartHourStr = '';
  let getEndHourStr = '';
  if (props.bookingOption?.rangeStartTimeSender) {
    getStartHourStr = props.selectedTimezone
      ? moment(props.bookingOption?.rangeStartTimeSender)
          .tz(props.selectedTimezone)
          .format(scheduleUtils.getTimeFormatStr(props.timeFormat))
      : moment(props.bookingOption?.rangeStartTimeSender).format(
          scheduleUtils.getTimeFormatStr(props.timeFormat),
        );
    if (props.bookingOption?.rangeEndTimeSender) {
      getEndHourStr = props.selectedTimezone
        ? moment(props.bookingOption.rangeEndTimeSender)
            .tz(props.selectedTimezone)
            .format(scheduleUtils.getTimeFormatStr(props.timeFormat))
        : moment(props.bookingOption.rangeEndTimeSender).format(
            scheduleUtils.getTimeFormatStr(props.timeFormat),
          );
    }
  } else if (props.firstAvailableTimeSlot) {
    getStartHourStr = props.firstAvailableTimeSlot;
  }
  return (
    <>
      <div
        className={`et-sr-s1-n-time-row-main-wrap  ${
          props.bookingOptionIndex !== undefined &&
          props.bookingOptionIndex === props.index
            ? ' et-sr-s1-n-time-row-main-wrap-selected'
            : ' '
        } `}>
        <div
          onMouseEnter={() => {
            props.setBookingRowIndForEditDelete(props.index);
          }}
          onMouseLeave={() => {
            props.setBookingRowIndForEditDelete(-1);
          }}
          className={`et-sr-s1-n-time-row-wrap`}
          onClick={() => {
            props.setBookingRowIndForEditDelete(props.index);
          }}>
          <div className="et-sr-n-bor-time-wrap">
            <div className="et-sr-s2-n-time-row-wrap-icon">
              <Calendar fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
            </div>
            <div
              className={'et-sr-bor-t1-n-value et-sr-bor-t1-n-value-day'}
              onClick={() => {
                props.handleDateClick(props.index);
              }}>
              {getDayStr + ' ' + getYearStr}
            </div>
            {props.showPrevNextBtn && (
              <div className="et-prev-next-btn-wrapper">
                <div
                  className="et-n-prev-icon"
                  onClick={() => {
                    const newDate = new Date(
                      moment(rangeStartTimeSenderDate, ['MMM YYYY']).add({
                        day: -1,
                      }),
                    );
                    props.onDateChanged(newDate);
                  }}>
                  <Caret fillColor="var(--et-mentor-primary-text-color)" />
                </div>
                <div
                  className="et-n-next-icon"
                  onClick={() => {
                    const newDate = new Date(
                      moment(rangeStartTimeSenderDate, ['MMM YYYY']).add({
                        day: 1,
                      }),
                    );
                    props.onDateChanged(newDate);
                  }}>
                  <Caret fillColor="var(--et-mentor-primary-text-color)" />
                </div>
              </div>
            )}
          </div>
          <div className="et-n-time-wrapper">
            <div className="">
              <Clock fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
            </div>
            <div className={'et-sr-bor-t1-n-value et-sr-bor-t1-n-value-time '}>
              {getEndHourStr
                ? getStartHourStr + ' - ' + getEndHourStr
                : getStartHourStr}
            </div>
          </div>

          {props.bookingRowIndForEditDelete === props.index &&
            props.showEditDeleteBtn && (
              <div
                className={`et-n-btn-container ${
                  props.bookingRowIndForEditDelete === props.index
                    ? 'et-n-show-container'
                    : 'et-n-hide-container'
                } `}>
                <button
                  className="et-n-edit-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    props.handleDateClick(props.index);
                  }}>
                  {context.languageSet.SCHEDULING.EDIT}
                </button>
                {props.showDelete && (
                  <button
                    className="et-n-delete-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      props.handleDelete(props.index);
                    }}>
                    {context.languageSet.SCHEDULING.DELETE}
                  </button>
                )}
              </div>
            )}
        </div>
        {isOverdue ? (
          <div className="et-n-booking-option-overdue-pill-wrap">
            <div className="et-n-booking-option-overdue-pill">Passed</div>
          </div>
        ) : props.showAcceptBtn ? (
          props.showSpinner ? (
            <div className="et-n-anonymous-bow-spinner et-n-white-bg-spinner">
              <ButtonComponent type="primary" image={<Spinner />} />
            </div>
          ) : (
            <div className="et-n-accept-btn-wrap">
              {/* todomcss : fix using windowScreenSize -> fixed */}
              {utilsService.isMobileDevice() ||
              (props.isAnonymousPage &&
                context.windowScreenSize ===
                  VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE) ? (
                <Check color="var(--et-mentor-cta-btn-primary-background-color-fc)" />
              ) : (
                <ButtonComponent
                  type="primary-outlined"
                  text="Accept"
                  onClick={props.handleAccept}
                />
              )}
            </div>
          )
        ) : null}
      </div>
    </>
  );
};

export default withWidgetContext(ClientBookingOptionRow);
